import { addDays, format } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import { UseFormReturn, useWatch } from "react-hook-form";

import orderCore, { OrderStatusArr } from "../../core/order.core";
import { useTranslation } from "../../core/translation.core";
import { OrderListFilter } from "../../types/order";
import { FancyCheckbox } from "../reuseables/checkbox.comp";
import XMarkIcon from "../../icons/xMark.icon";
import FunnelIcon from "../../icons/funnel.icon";
import SortByDate from "./sortByDate.comp";

export default function OrderFilters({ methods }: { methods: UseFormReturn<OrderListFilter, any> }) {
  return (
    <div className="flex flex-wrap gap-x-2 gap-y-2 lg:gap-3 items-center">
      <SortByStatus methods={methods} />
      <SortByDate methods={methods} />
      <ClearButton methods={methods} />
    </div>
  );
}

function ClearButton({ methods }: { methods: UseFormReturn<OrderListFilter, any> }) {
  function handleClear() {
    methods.reset({
      date: {
        from: format(addDays(new Date(), -365), "yyyy-MM-dd"),
        to: format(new Date(), "yyyy-MM-dd"),
      },
      orderStatuses: [],
      page: 1,
      pageSize: 20,
    });
  }

  return (
    <button
      onClick={handleClear}
      className="rounded-md font-light text-sm px-4 py-2 bg-white dark:bg-her-darkblue2  text-her-red flex items-center gap-3"
    >
      <XMarkIcon className="h-5 w-5" />
    </button>
  );
}

function SortByStatus({ methods }: { methods: UseFormReturn<OrderListFilter, any> }) {
  const { msg, t } = useTranslation();
  const [isOpened, setIsOpened] = useState(false);
  const ref = useRef<HTMLDivElement>();

  const status = useWatch({ control: methods.control, name: "orderStatuses" });

  useEffect(() => {
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  function onClick(e: MouseEvent) {
    // This is a hack to get the latest state
    if (!ref || !ref.current) return;
    const isOpened = (ref.current as any).getAttribute("data-state");

    if (!isOpened) return;

    const isWithin = (e.target as any).closest("#sortbystatus-selector");

    if (!isWithin) {
      setIsOpened(false);
    }
  }

  function toggleStatusPanel() {
    setIsOpened(!isOpened);
  }

  return (
    //  @ts-ignore
    <div className="relative" ref={ref} id="sortbystatus-selector" data-state={isOpened}>
      <button
        onClick={toggleStatusPanel}
        className="rounded-md text-sm px-4 py-2 bg-white dark:bg-her-darkblue2 dark:text-white flex items-center gap-3 min-w-[150px]"
      >
        <FunnelIcon className="w-5 h-5 text-her-pumpkin" />

        <span>
          {status && status.length !== 0
            ? status.map((s) => orderCore.getOrderStatusLocale(s, { msg, t })).join(", ")
            : t(msg.order.filterByStatus)}
        </span>
      </button>

      {isOpened && (
        <section className="flex flex-col text-sm absolute px-4 bg-white dark:bg-pos-dark dark:text-white top-11 left-0 w-full shadow-lg z-20">
          <div className="p-2 space-y-4">
            {OrderStatusArr.map((o) => (
              //  @ts-ignore
              <FancyCheckbox key={o} register={methods.register("orderStatuses")} value={o}>
                {orderCore.getOrderStatusLocale(o, { msg, t })}
              </FancyCheckbox>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
